<bepatient-question-title-v3
  [title]="question.label"
  [constraints]="question.constraints"
  [color]="color"
  [errors]="question.errors"
  [css]="question.css"
  [key]="question.key"
  [value]="value"
  [dirty]="dirty"
  [type]="question.controlType"
  [formGroup]="formGroup"
  [hasCondition]="question.hasCondition"
>
</bepatient-question-title-v3>

<ion-list [formGroup]="formGroup">
  <ion-item>
    <ion-select
      class="bepatient_dynamic_form_select"
      interface="popover"
      justify="space-between"
      [interfaceOptions]="customPopoverOptions"
      [placeholder]="question.placeholder | translate"
      [formControlName]="question.key"
      [attr.disabled]="question.disabled || question.readonly"
      [cancelText]="question.cancelText | translate"
      [okText]="question.okText | translate"
      (ionChange)="onSelect()"
      (ionBlur)="onBlur()"
    >
      <ion-select-option value="" *ngIf="!question.hideEmptyResponse">
        {{ 'EMPTY_RESPONSE' | translate }}
      </ion-select-option>
      <ion-select-option
        *ngFor="let option of question.options"
        [value]="option.value"
      >
        {{ option.key }}
      </ion-select-option>
    </ion-select>
  </ion-item>
</ion-list>
